<template>
  <div id="app">
    <router-view v-if="showContent"></router-view>
    <h2 v-else style="text-align: center;">连接中，请稍等……</h2>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      showContent: false
    }
  },
  computed: {
    isShowCommerHeader() {
      return this.$store.state.book.isShowCommerHeader && !this.$store.state.common.isStaticBook
    }
  },
  created() {
    const _this = this
    if (window.PROJECT_CONFIG.USER_URL) {
      let location = window.location.href.split('/index.html')[0]
      let paperNo = location.slice(location.lastIndexOf('/') + 1)
      // 判断权限和用户登录状态接口
      $.ajax({
        url: window.PROJECT_CONFIG.USER_URL,
        type: 'GET',
        data: {
          paperNo: paperNo
        },
        xhrFields: {withCredentials : true},
        success: function(res) {
          const data = typeof res == 'string' ? JSON.parse(res) : res
          console.log(data)
          if (data.status === 0) {
            _this.showContent = true
          }
          if (data.status !== 0) {
            if (data.message) {
              _this.$message({
                message: data.message,
                type: 'error'
              })
            }
            if (data.url) {
              window.location.href = data.url
            }
          }
        },
        error: function(err) {
          console.log(err)
          _this.showContent = false
        }
      })
    } else {
      this.showContent = true
    }
    // 保存刷新前的书刊专辑状态
    if (sessionStorage.getItem('userMsg')) {
      let manage = { manage: JSON.parse(sessionStorage.getItem('userMsg')) }
      this.$store.replaceState(Object.assign({}, this.$store.state, manage))
    }
    window.addEventListener('pagehide', () => {
      sessionStorage.setItem('userMsg', JSON.stringify(this.$store.state.manage))
    })
    // 全局捕获未处理的rejection
    window.addEventListener('unhandledrejection', function(event) {
      console.log('unhandledrejection', event.reason)
      event.preventDefault()
    })
  }
}
</script>

<style lang="scss">
body {
  /*min-width: 1000px;*/
  overflow: hidden;
}

#app {
  margin: 0 auto;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, 'Hiragino Sans GB', '微软雅黑', SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: #fff; */
}

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
